import {ChangeDetectorRef, Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {IonicModule, MenuController} from '@ionic/angular';
import coreData from '../../../assets/data/core.json';
import topHeaderData from '../../../assets/data/top-header.json';
import productsData from '../../../assets/data/products-header.json';
import {isPlatformBrowser, NgForOf, NgIf} from '@angular/common';
import {Router, RouterLink} from '@angular/router';
import {HomeService} from '../../services/home.service';
import {SubService} from '../../services/sub.service';
import {MiniCartComponent} from '../mini-cart/mini-cart.component';
import {ArbameService} from '../../services/arbame.service';
import {FormsModule} from '@angular/forms';

declare var require: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  standalone: true,
  imports: [
    IonicModule,
    NgIf,
    RouterLink,
    NgForOf,
    MiniCartComponent,
    FormsModule,
  ],
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  topHeader: any;
  headerOpen = false;
  products: any;
  selectedCatalog: any;
  homeData: any;
  isSticky = false;
  appInitData;
  cartOpen: any;
  isMobile = false;
  showSearch = false;
  basketCount = 0;

  constructor(@Inject(PLATFORM_ID) public platformId: any, @Inject(SubService) private sub: SubService, private router: Router, private aService: ArbameService, private menuCtrl: MenuController, private cdr: ChangeDetectorRef) {
    this.loadStaticContents();
    this.sub.appInitData.subscribe((data) => {
      this.appInitData = data;
      if (this.appInitData?.data?.cart_items_count) {
        this.basketCount = this.appInitData?.data?.cart_items_count;
      }
    });
    this.sub.isMobile.subscribe((data) => {
      if (data) {
        this.cdr.detectChanges();
        this.isMobile = data;
      }

    });
    this.sub.countCart.subscribe((data) => {
      if (data !== null) {
        this.basketCount = data;
      }
    });
    this.sub.cart.subscribe((data) => {
      if (data) {
        if (this.appInitData) {
          this.appInitData.data.cart_items_count = data.cart_items.length;
        }
        this.basketCount = data.cart_items.length;

        this.animateBadge = false;
        setTimeout(() => {
          this.animateBadge = true;
        }, 100);
      }
    });
  }

  menuData;
  animateBadge = true;
  searchInput: any;

  ngOnInit() {
    this.aService.getMenu().subscribe((data) => {
      this.menuData = data;
      if (this.menuData?.data?.length && !this.selectedCatalog) {
        this.selectedCatalog = this.menuData.data[0];
      }
    });
  }

  openProductsMenu() {
    this.headerOpen = true;
    if (!this.selectedCatalog && this.menuData?.data?.length) {
      this.selectedCatalog = this.menuData.data[0];
    }
  }


  loadStaticContents() {
    if (isPlatformBrowser(this.platformId)) {
      fetch(coreData.topHeader)
        .then((response) => {
          return response.json(); // Parse the JSON data
        })
        .then((data) => {
          this.topHeader = data;
        });
    }

    // fetch(coreData.productsHeader)
    //   .then((response) => {
    //     return response.json(); // Parse the JSON data
    //   })
    //   .then((data) => {
    //     this.products = data;
    //   });
  }

  openProfile() {
    if (!this.appInitData) {
      this.sub.openAuth.next(true);
    } else {
      this.router.navigate(['/dashboard']);
    }
  }

  joinTrader() {
    this.sub.joinTrade.next(true);
  }

  redirectToCatalog(item: any) {

  }

  openCart() {
    this.cartOpen = true;
    this.sub.reloadBasket.next(true);
  }

  searchTimeOut;
  searchResult;
  loadSearching = false;

  inputSearchChanged($event: any) {
    if (this.searchTimeOut) {
      clearTimeout(this.searchTimeOut);
    }
    this.loadSearching = true;
    this.searchTimeOut = setTimeout(() => {
      this.loadSearching = false;
      const fd = new FormData();
      fd.append('search', $event);
      fd.append('detailed', '0');
      this.aService.search(fd).subscribe((data) => {
        this.searchResult = data;
      });
    }, 1500);

  }

  redirectToSearch() {
    this.showSearch = false;
    this.router.navigate(['/search'], {queryParams: {search: this.searchInput}});
    setTimeout(() => {
      this.searchInput = '';
    }, 100);
  }

  redirectToProduct(item) {
    this.showSearch = false;
    this.router.navigate([`/products/${item.catalog_alias}/${item.collection_alias}/${item.id}/${item.title_alias}`]);
  }
}
